import { Component } from 'react';
import { IconName } from '@optimus-web/icons';
import { noop } from '../utils/func';
import { extractAriaProps } from '../utils/extractAriaProps';
import {
    CheckedIconElement,
    IconElement,
    NativeControlElement,
    ToggleBackgroundElement,
    ToggleKnobElement,
    ToggleWrapperElement,
} from './style';

interface ToggleProps {
    checked: boolean;
    onChange: (event: React.SyntheticEvent<HTMLElement>, checked: boolean) => void;
    disabled?: boolean;
    offIcon?: IconName;
    onIcon?: IconName;
    offBackgroundIcon?: IconName;
    onBackgroundIcon?: IconName;
}

class Toggle extends Component<ToggleProps> {
    static defaultProps = {
        checked: false,
        disabled: false,
        onChange: noop,
    };

    handleToggle = (event: React.SyntheticEvent<HTMLElement>) => {
        if (this.props.disabled) {
            return;
        }
        this.toggleCheck(event);
    };

    toggleCheck = (event: React.SyntheticEvent<HTMLElement>) => {
        this.props.onChange(event, !this.props.checked);
    };

    render() {
        const { disabled, onIcon, offIcon, onBackgroundIcon, offBackgroundIcon, checked, onChange, ...other } =
            this.props;

        const [ariaProps, restProps] = extractAriaProps(other);

        const nativeControlProps = {
            checked,
            disabled,
            onClick: this.handleToggle,
            readOnly: true,
            ...ariaProps,
        };

        const toggleProps = { disabled, checked };

        const knob = (
            <>
                {checked && onBackgroundIcon && <CheckedIconElement disabled={disabled} value={onBackgroundIcon} />}
                <ToggleKnobElement {...toggleProps}>
                    {checked && onIcon && <CheckedIconElement disabled={disabled} value={onIcon} />}
                    {!checked && offIcon && <IconElement disabled={disabled} value={offIcon} />}
                </ToggleKnobElement>
                {!checked && offBackgroundIcon && <IconElement disabled={disabled} value={offBackgroundIcon} />}
            </>
        );

        return (
            <ToggleWrapperElement {...restProps} disabled={disabled} checked={checked}>
                <NativeControlElement {...nativeControlProps} data-test-toggle />
                <ToggleBackgroundElement {...toggleProps}>{knob}</ToggleBackgroundElement>
            </ToggleWrapperElement>
        );
    }
}

export { Toggle };
